<template>
	<div v-if="usps.length" class="flex flex-col gap-2 p-4 border border-gold-500 rounded-lg bg-white/5">
		<div v-for="(usp, index) in usps" :key="index" class="relative flex items-start gap-3 text-sm text-white">
			<SvgIcon name="check" class="size-4 mt-0.5 flex-none text-gold-500" />
			<span>
				{{ usp.text }}
				<button
					v-if="usp.tooltip"
					type="button"
					class="inline-flex align-middle ml-1.5 group/tooltip"
					:aria-label="t('more_info')"
					:aria-expanded="openIndex === index"
					:aria-describedby="`usp-tooltip-${index}`"
					@click.stop="toggleTooltip(index)"
				>
					<SvgIcon name="tooltip" class="size-4 text-white/70" />
					<!-- Spans the row width, so it always stays within the viewport -->
					<span
						:id="`usp-tooltip-${index}`"
						role="tooltip"
						:class="[
							'absolute z-20 bottom-full left-0 right-0 mb-2 p-3 rounded bg-white text-neutral-950 text-xs text-left normal-case shadow-md transition-opacity duration-150',
							openIndex === index
								? 'opacity-100'
								: 'opacity-0 pointer-events-none group-hover/tooltip:opacity-100 group-focus-visible/tooltip:opacity-100',
						]"
					>
						{{ usp.tooltip }}
					</span>
				</button>
			</span>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { UspBlockItem } from '../api/resources';
import SvgIcon from './SvgIcon.vue';

defineProps<{
  usps: UspBlockItem[];
}>();

const { t } = useI18n();

// Hover only works on desktop; on touch devices the tooltip toggles on tap
const openIndex = ref<number | null>(null);

const toggleTooltip = (index: number) => {
  openIndex.value = openIndex.value === index ? null : index;
};

const closeTooltip = () => {
  openIndex.value = null;
};

const onKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') closeTooltip();
};

onMounted(() => {
  document.addEventListener('click', closeTooltip);
  document.addEventListener('keydown', onKeydown);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', closeTooltip);
  document.removeEventListener('keydown', onKeydown);
});
</script>
